export default ({ html }) => html`
  <polygon points="7.5 16.75 5.75 15 10.75 10 5.75 5 7.5 3.25 14.25 10" />
`
